<template>
    <div class="flex-vertically-center pk-number">
        <div class="run">
            <div class="num">{{ todaySituation.pk_count || 0 }}</div>
            <div class="name">PK局数</div>
        </div>
        <div class="run">
            <div class="num" >
                <span class="num-li">
                    {{ todaySituation.join_num || 0 }}
                    <div class="tips" v-if="todaySituation.time_type && todaySituation.time_type.indexOf('3') > 0">{{
                        todaySituation.no_join_num ||
                            0
                    }}人未PK</div>
                </span>
            </div>
            <div class="name">PK的人数</div>
        </div>
        <div class="run">
            <div class="num">{{
                Math.round(Number(todaySituation.win_rate || 0) / 100)
            }}%
            </div>
            <div class="name">胜率</div>
        </div>
        <div class="run">
            <div class="num">{{ todaySituation.one_day_score || 0 }}</div>
            <div class="name">单日奖杯数</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        todaySituation: {
            type: Object,
            default: () => { }
        }
    },
    mounted(){
        this.$set(this, 'todaySituation', this.todaySituation || {})
        console.log('---===',this.todaySituation)
    }
}
</script>
<style lang="less" scoped>

</style>